import { render, staticRenderFns } from "./PositionPageMenu.vue?vue&type=template&id=3113aa9d&scoped=true"
import script from "./PositionPageMenu.vue?vue&type=script&lang=js"
export * from "./PositionPageMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3113aa9d",
  null
  
)

export default component.exports